import { JetView } from 'webix-jet';
import { devConfig, countries, profile, providersCasino } from 'config/config';

/**
 * Class representing the Filter Sessions Report View.
 * @extends JetView
 */
export default class FilterSessionsReportView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'SessionId',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Sesión'),
                            labelPosition: 'top',
                            placeholder: _('ID Sesión'),
                            invalidMessage: _('ID Session is required'),
                        },
                        {
                            view: 'text',
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'),
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'datepicker',
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de creación'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'),
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(),
                                },
                            },
                        },
                        {
                            view: 'richselect',
                            name: 'State',
                            label: _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Estado'),
                            options: [
                                { id: 'A', value: _('Activo') },
                                { id: 'I', value: _('Inactivo') },
                            ],
                        },
                        {
                            view: 'combo',
                            name: 'ProviderId',
                            localId: 'provider:combo',
                            label: _('Proveedor'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/ProvidersCasinoSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! ');
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (!resp.HasError) {
                                                                vthis.parse(resp.Data);
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'),
                    width: 100,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues());
                        $$('CountrySelect').setValue($$('myForm').getCleanValues().CountrySelect);
                        $$('Datepicker').setValue('');
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    width: 110,
                    click: () => {
                        const filterdata = this.getRoot().getValues();
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry;
                        }
                        delete filterdata['CountrySelect2'];
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date'];
                        } else {
                            if (true) {
                                delete filterdata['Datepicker'];
                            }
                        }
                        this.app.callEvent('sessionReport:filter', [filterdata]);
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button',
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').clear();
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues();
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date'];
                        } else {
                            if (profile.typeDate == 2) {
                                delete filterdata['Datepicker'];
                            }
                        }
                        this.app.callEvent('sessionReport:filter', [filterdata]);
                        $$('filterPopup').hide();
                    },
                },
            ],
        };
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'),
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons],
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section],
            },
        };
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2],
                rules: {
                    fname: webix.rules.isNotEmpty,
                },
            },
        });
        return {
            view: 'form',
            id: 'myForm',
            type: 'clean',
            rows: [screen.width > 500 && screen.height > 500 ? accordion_section : { height: 1, width: 0 }],
            rules: {
                fname: webix.rules.isNotEmpty,
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide();
                $$('Datepicker').show();
            } else {
                if (true) {
                    $$('Date').show();
                    $$('Datepicker').hide();
                }
            }
        });
        const lang = this.app.getService('locale').getLang();
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang);
        });
    }
}

// FILE DOCUMENTED
